import React from 'react';
import Select, { StylesConfig } from 'react-select';

interface OptionType {
  readonly label: string;
  readonly value: string;
}

interface ResourcesDropdownProps {
  readonly selectedResourceId: string;
  readonly options: OptionType[];
  readonly onChange: (option: OptionType) => void;
}

const customStyles: StylesConfig<OptionType, false> = {
  control: (base) => ({
    ...base,
    height: '48.5px',
    width: '175px',
    border: '0.5px solid #ccc',
    borderRadius: '0px',
    boxShadow: 'none',
    paddingLeft: '1px',
    fontSize: '14px',
    fontWeight: '400',
    color: '#000',
    position: 'relative',
    backgroundColor: '#fff',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#000',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#333',
    paddingRight: '16px',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (base) => ({
    ...base,
    borderRadius: 0,
    marginTop: '4px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    fontSize: '20px',
    backgroundColor: '#fff',
  }),
  option: (base, state) => ({
    ...base,
    padding: '12px',
    fontSize: '14px',
    backgroundColor: state.isFocused ? '#f3f3f3' : '#fff',
    color: '#000',
    cursor: 'pointer',
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: '#999',
    padding: '12px',
    fontSize: '14px',
  }),
};

export const ResourcesDropdown: React.FC<ResourcesDropdownProps> = ({
  selectedResourceId,
  options,
  onChange,
}) => {
  const selectedOption =
    options.find((option) => option.value === selectedResourceId) || null;

  return (
    <Select
      styles={customStyles}
      autoFocus
      controlShouldRenderValue
      options={options}
      onChange={(option) => onChange(option as OptionType)}
      value={selectedOption}
      placeholder=""
      isClearable={false}
      isSearchable={false}
      isMulti={false}
    />
  );
};
